import { useCookies } from 'react-cookie';
import logo_icon from '../images/Full-Colour Icon PNG.png'
import logo_word from '../images/Full-Colour Wordmark PNG.png'
import {useCart} from '../hooks/add_to_cart';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserAlt } from 'react-icons/fa';
import { MdOutlineShoppingBasket } from 'react-icons/md';
import { LoginModal } from './account_modal';

export default function Navbar() {
  const {getCartTotal} = useCart();
  const [cookies, setCookie, removeCookie] = useCookies();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    // setCookie("user_country", 'NG', {
    //   path: "/",
    //   maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
    //   secure: true,
    //   sameSite: "strict"
    // });
  }, [])

  function changeCountry(val) {
    setCookie("user_country", val, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });
  }
  
  return (
    <header className="border-b">
      {showModal && <LoginModal
        setShowModal={setShowModal}
        showModal={showModal}
      />}
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-center md:justify-between">
        {/* <h1 className="text-xl font-bold">Elle Trendy Hair</h1> */}
        <div onClick={() => navigate('/')} className='flex flex-row justify-start items-center cursor-pointer'>
            <img src={logo_icon} className="h-[50px] md:h-[70px] md:mr-2" alt="logo" />
            {/* <img src={logo_word} className="h-[30px] md:h-[40px]" alt="logo" /> */}
        </div>
        <nav className="flex gap-6 text-xs md:text-sm my-2 md:my-0">
            <span className='gap-x-2 flex flex-row items-center cursor-pointer'><FaUserAlt size={15} color='#585858' /><a onClick={() => setShowModal(true)}>{cookies?.billingInfo != undefined ? cookies?.billingInfo?.email : 'Account'}</a></span>
            <span className='gap-x-2 flex flex-row items-center'><a href="/my-cart">My Cart ({getCartTotal()})</a><MdOutlineShoppingBasket size={20} color='#585858' /></span>
            <select value={cookies?.user_country} selected={cookies?.user_country} onChange={(e) => changeCountry(e.target.value)} className="hidden md:block border px-2 py-1 text-sm">
                <option value="">Default</option>
                <option value="US">Other Regions</option>
                <option value="NG">Nigeria</option>
            </select>
        </nav>
      </div>

      <div className="w-full justify-center gap-2 px-2 py-2 text-xs flex md:gap-6 md:px-4 md:py-3 md:text-sm border-t">
        {["New Arrivals","Best Sellers","Fashion Accessories"].map(i => (
          <span onClick={() => navigate('/shop-now', {state: {sort: i}})} className="px-1 text-center md:px-3 font-medium md:font-semibold cursor-pointer" key={i}>{i}</span>
        ))}
          <span onClick={() => window.open('https://api.whatsapp.com/message/EJMNVMDG22ZTP1?autoload=1&app_absent=0%0A', '_blank')} className="px-1 text-center md:px-3 font-medium md:font-semibold cursor-pointer">{'Talk to Us'}</span>
          <span onClick={() => navigate('/book-fitting')} className="px-1 text-center md:px-3 font-medium md:font-semibold cursor-pointer">{'Book a Fitting'}</span>
      </div>
    </header>
  )
}
